import { apiSlice } from '../api/apiSlice'
import { RequestProps } from '../../types'
import PushNotification from '../../types/models/PushNotification'
import PushNotificationsResponse from '../../types/response/PushNotificationsResponse'
import MissingHoursNotificationSendRequest from '../../types/models/MissingHoursNotification'
import AdministrativeNotificationSendRequest from '../../types/models/AdministrativeNotification'

export const pushNotificationSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPushNotifications: builder.query<PushNotificationsResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: 'notifications',
        params: props,
      }),
      providesTags: () => [{ type: 'PushNotification', id: 'LIST' }],
    }),

    markPushNotificationRead: builder.mutation<PushNotification, string>({
      query: (id: string) => ({
        url: `notifications/${id}/read`,
        method: 'POST',
      }),
      invalidatesTags: () => [{ type: 'PushNotification', id: 'LIST' }, { type: 'VacationAcknowledgement' }],
    }),

    sendAdministrativeNotification: builder.mutation<void, AdministrativeNotificationSendRequest>({
      query: body => ({
        url: `notifications/dispatch/administrative`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => [{ type: 'PushNotification', id: 'LIST' }],
    }),

    sendMissingHoursNotification: builder.mutation<void, MissingHoursNotificationSendRequest>({
      query: body => ({
        url: `notifications/dispatch/missing-hours`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => [{ type: 'PushNotification', id: 'LIST' }],
    }),

    markAllPushNotificationsRead: builder.mutation<PushNotification[], void>({
      query: () => ({
        url: `notifications/readAll`,
        method: 'POST',
      }),
      invalidatesTags: () => [{ type: 'PushNotification', id: 'LIST' }, { type: 'VacationAcknowledgement' }],
    }),
  }),
})

export const {
  useGetPushNotificationsQuery,
  useLazyGetPushNotificationsQuery,
  useMarkPushNotificationReadMutation,
  useMarkAllPushNotificationsReadMutation,
  useSendAdministrativeNotificationMutation,
  useSendMissingHoursNotificationMutation,
} = pushNotificationSlice
